import {X} from 'lucide-react';

import {cn} from '../../lib/utils';

import type {KeyboardEvent, MouseEvent} from 'react';

export interface OptionTagProps {
  label: string;
  onRemove: (e: MouseEvent<HTMLElement>) => void;
  removeLabel?: string;
  className?: string;
}

export function OptionTag({label, onRemove, removeLabel = 'Remove', className}: OptionTagProps) {
  const handleKeyDown = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.currentTarget.click();
    }
  };

  return (
    <span
      data-slot="multi-select-tag"
      className={cn(
        'inline-flex items-center gap-0.5 rounded-sm border border-border bg-background-surface pe-1 ps-1.25 py-0.5 text-sm font-medium text-fg-secondary',
        className
      )}
    >
      {label}
      <span
        role="button"
        tabIndex={0}
        onClick={onRemove}
        onKeyDown={handleKeyDown}
        className="ms-0.5 cursor-pointer rounded-sm text-fg-tertiary transition-colors hover:text-fg focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-1"
        aria-label={`${removeLabel} ${label}`}
      >
        <X className="size-3" />
      </span>
    </span>
  );
}
